import React, { Component } from 'react';
import moment from 'moment';
import API from '../../utils/API';
import SaveBar from './components/SaveBar';

const formatDateForInput = (value) => {
	if (!value) return '';
	if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
	return moment.utc(value).format('YYYY-MM-DD');
};

const AMENITY_OPTIONS = [
	'Spa/Salon',
	'Golf',
	'On Site Restaurant(s)',
	'Valet Parking',
	'Self Parking',
	'Business Center',
	'Outdoor Pool',
	'Indoor Pool',
	'Fitness Center'
];

class AdditionalInfo extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: {
				responseDueDate: null,
				decisionDate: null,
				requestedAmenities: [],
				eventDescription: '',
				decisionFactors: '',
				budgetDirection: '',
				...(props.request?.additionalInfo || {})
			},
			editing: false,
			saving: false
		};
	}

	update = (field, value) => {
		this.setState((s) => ({ data: { ...s.data, [field]: value }, editing: true }));
	};

	toggleAmenity = (amenity) => {
		this.setState((s) => {
			const current = s.data.requestedAmenities || [];
			const next = current.includes(amenity)
				? current.filter((a) => a !== amenity)
				: [...current, amenity];
			return { data: { ...s.data, requestedAmenities: next }, editing: true };
		});
	};

	save = async () => {
		this.setState({ saving: true });
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/proposal-requests/${this.props.requestId}`,
				{ additionalInfo: this.state.data }
			);
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (e) {
			console.error('Error saving additional info:', e);
			this.setState({ saving: false });
		}
	};

	cancel = () => {
		this.setState({
			data: {
				responseDueDate: null,
				decisionDate: null,
				requestedAmenities: [],
				eventDescription: '',
				decisionFactors: '',
				budgetDirection: '',
				...(this.props.request?.additionalInfo || {})
			},
			editing: false
		});
	};

	render() {
		const { data, editing, saving } = this.state;
		const { request } = this.props;

		const responseDueDateVal = formatDateForInput(data.responseDueDate);
		const decisionDateVal = formatDateForInput(data.decisionDate);

		return (
			<>
				{/* ── Timeline ─────────────────────────────────────── */}
				<h2 className="pr-subsection-title" style={{ marginTop: 0 }}>Timeline</h2>

				<div className="pr-row-2" style={{ marginBottom: 32 }}>
					<div className="pr-field-group compact">
						<label className="pr-field-label">Response Due Date</label>
						<div className="rfp-date-input-wrap">
							<input
								className="rfp-date-input"
								type="date"
								value={responseDueDateVal}
								onChange={(e) => this.update('responseDueDate', e.target.value)}
							/>
							<i className="las la-calendar rfp-date-icon" />
						</div>
					</div>
					<div className="pr-field-group compact">
						<label className="pr-field-label">Decision Date</label>
						<div className="rfp-date-input-wrap">
							<input
								className="rfp-date-input"
								type="date"
								value={decisionDateVal}
								onChange={(e) => this.update('decisionDate', e.target.value)}
							/>
							<i className="las la-calendar rfp-date-icon" />
						</div>
					</div>
				</div>

				{/* ── Requested Amenities ───────────────────────────── */}
				<h2 className="pr-subsection-title">Requested Amenities</h2>
				<p className="pr-field-sublabel">Select all amenities that are important for your event.</p>

				<div className="pr-check-list" style={{ marginBottom: 32 }}>
					{AMENITY_OPTIONS.map((amenity) => {
						const on = (data.requestedAmenities || []).includes(amenity);
						return (
							<button
								key={amenity}
								type="button"
								className={`pr-check-row ${on ? 'checked' : ''}`}
								onClick={() => this.toggleAmenity(amenity)}
							>
								<span className="pr-check-box">
									<i className="las la-check" />
								</span>
								<span>{amenity}</span>
							</button>
						);
					})}
				</div>

				{/* ── Event Details & Requirements ──────────────────── */}
				<h2 className="pr-subsection-title">Event Details &amp; Requirements</h2>

				<div className="pr-field-group">
					<label className="pr-field-label">Event Description / Requests</label>
					<textarea
						className="pr-textarea"
						rows={4}
						value={data.eventDescription || ''}
						onChange={(e) => this.update('eventDescription', e.target.value)}
						placeholder="Provide a detailed description of your event and any special requests…"
					/>
				</div>

				<div className="pr-field-group">
					<label className="pr-field-label">Decision Factors</label>
					<textarea
						className="pr-textarea"
						rows={4}
						value={data.decisionFactors || ''}
						onChange={(e) => this.update('decisionFactors', e.target.value)}
						placeholder="What factors are most important in your venue selection decision?…"
					/>
				</div>

				<div className="pr-field-group">
					<label className="pr-field-label">Budget Direction &amp; Historical Spend</label>
					<textarea
						className="pr-textarea"
						rows={4}
						value={data.budgetDirection || ''}
						onChange={(e) => this.update('budgetDirection', e.target.value)}
						placeholder="Provide budget guidance and any relevant historical spend information…"
					/>
				</div>

				<SaveBar
					editing={editing}
					saving={saving}
					onSave={this.save}
					onCancel={this.cancel}
					updatedAt={request?.updatedAt}
				/>
			</>
		);
	}
}

export default AdditionalInfo;
